import React, { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatError } from "@/lib/api";
import { AuthShell, Field } from "./Login";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [devLink, setDevLink] = useState(null);
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try {
      const r = await api.post("/auth/forgot-password", { email });
      setDevLink(r.data.reset_link_dev || null);
      setDone(true);
    } catch (e) { setErr(formatError(e)); }
    finally { setLoading(false); }
  };

  if (done) return (
    <AuthShell title="Check je inbox" subtitle="Reset-link verzonden">
      <p className="text-slate-700 mb-3">Als <strong>{email}</strong> bekend is, sturen we een reset-link (vanaf <strong>Sprongchecker</strong>).</p>
      {devLink && <div className="p-3 bg-slate-50 border rounded text-xs break-all" data-testid="dev-reset-link"><a href={devLink} className="text-orange-600 underline">{devLink}</a></div>}
      <Link to="/login" className="mt-6 inline-block text-orange-600 hover:underline" data-testid="back-login">Terug naar inloggen</Link>
    </AuthShell>
  );

  return (
    <AuthShell title="Wachtwoord vergeten" subtitle="We mailen een reset-link">
      <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
        <Field label="E-mail" type="email" value={email} onChange={setEmail} testid="forgot-email"/>
        {err && <div className="text-red-600 text-sm">{err}</div>}
        <button type="submit" disabled={loading} className="w-full bg-orange-500 hover:bg-orange-600 text-white font-semibold py-3 rounded-lg disabled:opacity-50" data-testid="forgot-submit">
          {loading ? "Bezig..." : "Stuur reset-link"}
        </button>
        <Link to="/login" className="block text-sm text-center text-slate-600 hover:underline">Terug naar inloggen</Link>
      </form>
    </AuthShell>
  );
}
